var _rect, _rect2, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackToTop = function SvgBackToTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#ED1C25",
    rx: 100
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 184.24,
    height: 184.24,
    x: 7.88,
    y: 7.88,
    fill: "#ED1C25",
    rx: 92.12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 184.24,
    height: 184.24,
    x: 7.88,
    y: 7.88,
    stroke: "#F8A4A7",
    strokeWidth: 3.76,
    rx: 92.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59 103.257v-16.6a4 4 0 0 1 1.172-2.829l38.914-38.914a2 2 0 0 1 2.828 0l38.914 38.914A4 4 0 0 1 142 86.657v16.6c0 2.673-3.231 4.012-5.121 2.122l-34.965-34.965a2 2 0 0 0-2.828 0L64.12 105.38c-1.89 1.89-5.121.551-5.121-2.122"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59 148.757v-16.6c0-1.061.421-2.078 1.172-2.829l38.914-38.914a2 2 0 0 1 2.828 0l38.914 38.914a4 4 0 0 1 1.172 2.829v16.6c0 2.673-3.231 4.012-5.121 2.122l-34.965-34.965a2 2 0 0 0-2.828 0L64.12 150.879c-1.89 1.89-5.121.551-5.121-2.122"
  })));
};
export default SvgBackToTop;